
import * as slimeCore from '@qsk/slime-core';
import slime_components_float_icon from '@qsk/slime-components-float-icon';
import slime_components_calendar_subscribe from '@qsk/slime-components-calendar-subscribe';
import slime_components_anchor from '@qsk/slime-components-anchor';
import slime_components_coupon from '@qsk/slime-components-coupon';
import slime_components_gap from '@qsk/slime-components-gap';
import slime_components_banner from '@qsk/slime-components-banner';
import slime_components_subscribe from '@qsk/slime-components-subscribe';
import slime_components_textarea from '@qsk/slime-components-textarea';
import slime_components_seckill_tabs from '@qsk/slime-components-seckill-tabs';
import slime_components_hotspots from '@qsk/slime-components-hotspots';
import slime_components_bottom_nav from '@qsk/slime-components-bottom-nav';
import slime_components_video from '@qsk/slime-components-video';
import slime_components_goods from '@qsk/slime-components-goods';
import slime_components_tabs from '@qsk/slime-components-tabs';
import slime_components_seckill_list from '@qsk/slime-components-seckill-list';
import slime_components_cash_back_activity from '@qsk/slime-components-cash-back-activity';
import slime_components_lottery from '@qsk/slime-components-lottery';
import slime_components_table from '@qsk/slime-components-table';
import slime_components_new_user_coupon from '@qsk/slime-components-new-user-coupon';
import slime_components_tq_repurchase from '@qsk/slime-components-tq-repurchase';
import slime_components_editor from '@qsk/slime-components-editor';
import slime_components_buying from '@qsk/slime-components-buying';
import slime_components_bl_card from '@qsk/slime-components-bl-card';
import slime_components_freebuy from '@qsk/slime-components-freebuy';
import slime_components_user_callback_redpacket from '@qsk/slime-components-user-callback-redpacket';
import slime_components_bl_confirm_userinfo from '@qsk/slime-components-bl-confirm-userinfo';
import slime_components_bl_confirm_timedown from '@qsk/slime-components-bl-confirm-timedown';
import slime_components_bl_confirm_price from '@qsk/slime-components-bl-confirm-price';
import slime_components_bl_confirm_pay from '@qsk/slime-components-bl-confirm-pay';
import slime_components_bl_Intercept_popup from '@qsk/slime-components-bl-Intercept-popup';
import slime_components_bl_air_countdown from '@qsk/slime-components-bl-air-countdown';
import slime_components_bl_carousel from '@qsk/slime-components-bl-carousel';
import slime_components_social_productcard from '@qsk/slime-components-social-productcard';
import slime_components_social_coupon from '@qsk/slime-components-social-coupon';
import slime_components_hotspot_hoc from '@qsk/slime-components-hotspot-hoc';
import slime_components_freebuy_row from '@qsk/slime-components-freebuy-row';
import slime_components_coupon_nav from '@qsk/slime-components-coupon-nav';
import slime_components_coupon_list from '@qsk/slime-components-coupon-list';
import slime_components_fixed_custom_header from '@qsk/slime-components-fixed-custom-header';
import slime_components_new_user_coupon_marquee from '@qsk/slime-components-new-user-coupon-marquee';
import slime_components_buyTips from '@qsk/slime-components-buyTips';
import slime_components_promo_subscribe from '@qsk/slime-components-promo-subscribe';
import slime_components_tq_takeout_ab_hotspot from '@qsk/slime-components-tq-takeout-ab-hotspot';
import slime_components_bl_card_pay from '@qsk/slime-components-bl-card-pay';
import slime_components_coupon_new from '@qsk/slime-components-coupon-new';
import slime_components_bbox_entry from '@qsk/slime-components-bbox-entry';
import slime_components_douyin_studio from '@qsk/slime-components-douyin-studio';
import slime_components_bbox_travel from '@qsk/slime-components-bbox-travel';
import slime_components_live_list from '@qsk/slime-components-live-list';
import slime_components_privilege_ele_newuser from '@qsk/slime-components-privilege-ele-newuser';
import slime_components_privilege_oil_coupon from '@qsk/slime-components-privilege-oil-coupon';
import slime_components_coupon_auto_received from '@qsk/slime-components-coupon-auto-received';
import slime_components_oil_cart_products_exchange from '@qsk/slime-components-oil-cart-products-exchange';


const componentArray = [
  slime_components_float_icon,
  slime_components_calendar_subscribe,
  slime_components_anchor,
  slime_components_coupon,
  slime_components_gap,
  slime_components_banner,
  slime_components_subscribe,
  slime_components_textarea,
  slime_components_seckill_tabs,
  slime_components_hotspots,
  slime_components_bottom_nav,
  slime_components_video,
  slime_components_goods,
  slime_components_tabs,
  slime_components_seckill_list,
  slime_components_cash_back_activity,
  slime_components_lottery,
  slime_components_table,
  slime_components_new_user_coupon,
  slime_components_tq_repurchase,
  slime_components_editor,
  slime_components_buying,
  slime_components_bl_card,
  slime_components_freebuy,
  slime_components_user_callback_redpacket,
  slime_components_bl_confirm_userinfo,
  slime_components_bl_confirm_timedown,
  slime_components_bl_confirm_price,
  slime_components_bl_confirm_pay,
  slime_components_bl_Intercept_popup,
  slime_components_bl_air_countdown,
  slime_components_bl_carousel,
  slime_components_social_productcard,
  slime_components_social_coupon,
  slime_components_hotspot_hoc,
  slime_components_freebuy_row,
  slime_components_coupon_nav,
  slime_components_coupon_list,
  slime_components_fixed_custom_header,
  slime_components_new_user_coupon_marquee,
  slime_components_buyTips,
  slime_components_promo_subscribe,
  slime_components_tq_takeout_ab_hotspot,
  slime_components_bl_card_pay,
  slime_components_coupon_new,
  slime_components_bbox_entry,
  slime_components_douyin_studio,
  slime_components_bbox_travel,
  slime_components_live_list,
  slime_components_privilege_ele_newuser,
  slime_components_privilege_oil_coupon,
  slime_components_coupon_auto_received,
  slime_components_oil_cart_products_exchange,

];

function registerCmp(array) {
  array.forEach((register) => {
    if (register instanceof Array) {
      registerCmp(register);
    } else {
      slimeCore.register(register);
    }
  });
}
registerCmp(componentArray);
